import PropTypes from 'prop-types'
import React from 'react'
import {
  skin,
  withGAEvent,
  contentCardGALabel,
  createContentCardGAProps,
  path,
  transformImageURL
} from 'Utils'
import get from 'lodash/get'
import skins from '../skins'
import config, { gaSettings } from 'Config'
import { Link } from 'Blocks'

const ContentListItem = ({
  className = '',
  pageName = '',
  item,
  position = 0
}) => {
  const { type, title, uuid, slug } = item
  const cardGASettings = gaSettings[type].ContentCard
  const labelProps = {
    ...{ uuid },
    ...{ type },
    ...{ position }
  }

  const label = contentCardGALabel(labelProps)
  const additionalProps = createContentCardGAProps(labelProps)
  const GALink = withGAEvent(Link, {
    category: cardGASettings.category.replace('$pageName', pageName),
    action: cardGASettings.action,
    label: label.join(' - '),
    additionalProps,
  })

  const { withExtraInfo } = config.articleCard
  const { showTaggedCategory, showSponsoredBy } = config.article
  let subText = ''
  const categoryName = get(item, 'theme', false)
  const isSponsored = get(item, 'sponsor', false)

  if (showSponsoredBy && isSponsored) {
    subText = `Sponsored`
  } else if (showTaggedCategory && categoryName) {
    subText = categoryName
  }

  return (
    <GALink to={path(type, { uuid, slug })} className="contentlist__item">
      <div className={`${className} article-list__firstArticle`}>
        <div className="al__row1">
          <h1>{item.title.long}</h1>
          {withExtraInfo && <p className="al__category-name">{subText}</p>}
        </div>
        <div className="al__row2">
          <img
            src={transformImageURL(item.image.main, {
              crop: 'scale',
              width: '800'
            })}
          />
        </div>
      </div>
    </GALink>
  )
}

ContentListItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    image: PropTypes.shape({
      main: PropTypes.any
    }),
    slug: PropTypes.any,
    title: PropTypes.shape({
      long: PropTypes.any
    }),
    type: PropTypes.any,
    uuid: PropTypes.any
  }),
  pageName: PropTypes.string,
  position: PropTypes.number
}

export default skin(ContentListItem, skins)
